import { useMemo } from "react";
import { DCUIContent, DCUITheme } from "@iddataweb/idw-common-ui/types";
import { SanitizedHtmlContainer } from "@iddataweb/idw-common-ui/containers";
import { ButtonTypes } from "@enums/button-types";
import { PreviewEntityTypes } from "@enums/preview-entity-types";
import { DCUIThemingStep } from "@idw-types/common/dcui/dcui-theming-step";
import {
    getCaptureStepLabel,
    getCaptureStepStartInstructionsImageUrl,
} from "@utils/dcui-capture-step-util";
import { DCUIThemingPrimaryButton } from "../dcui-theming-primary-button/dcui-theming-primary-button";
import styles from "./dcui-theming-start-page.less";

type DCUIThemingStartPageProps = {
    dcuiContent: DCUIContent;
    dcuiTheme: DCUITheme;
    captureSteps: Array<DCUIThemingStep>;
    isStartingCapture: boolean;
    previewEntityType: PreviewEntityTypes;
};

export const DCUIThemingStartPage = (props: DCUIThemingStartPageProps) => {
    const { dcuiContent, dcuiTheme, captureSteps, isStartingCapture, previewEntityType } = props;

    const buttonText = useMemo(() => {
        return isStartingCapture
            ? dcuiContent.start.loadingButtonText
            : dcuiContent.start.buttonText;
    }, [dcuiContent.start.loadingButtonText, dcuiContent.start.buttonText, isStartingCapture]);

    const headline = dcuiContent.start.headline;
    const title = dcuiContent.start.title;
    const explanationHtml = dcuiContent.start.explanationHtml;
    const subheading = dcuiContent.start.subHeading;

    return (
        <div className={styles.dcuiThemingStartPage}>
            {headline && (
                <SanitizedHtmlContainer html={`<h1>${headline}</h1>`} />
            )}
            {title && (
                <SanitizedHtmlContainer html={`<p>${title}</p>`} />
            )}
            {explanationHtml && (
                <SanitizedHtmlContainer html={`<span>${explanationHtml}</span>`} className={styles.explanationHtml} />
            )}
            <p className={styles.subheading}>{subheading}</p>
            {previewEntityType === PreviewEntityTypes.VERIFICATION_SERVICE && captureSteps.map(captureStep => (
                <div className={styles.stepContainer} key={`dcui-theming-capture-step-${captureStep.stepType}`}>
                    <img src={getCaptureStepStartInstructionsImageUrl(captureStep.stepType, dcuiContent)} />
                    <label>{getCaptureStepLabel(captureStep.stepType, dcuiContent)}</label>
                </div>
            ))}
            {previewEntityType === PreviewEntityTypes.WORKFLOW && (
                <div className={styles.previewContainer}>
                    <span>Capture Steps Section</span>
                    <span>Service specific capture steps would go here</span>
                </div>
            )}
            <div className={styles.startButtonContainer}>
                <DCUIThemingPrimaryButton
                    generalTheme={dcuiTheme.general}
                    id="dcui-start-button"
                    disabled={isStartingCapture}
                    label={buttonText}
                    type={ButtonTypes.BUTTON}
                />
            </div>
        </div>
    );
};